import { createFileRoute, Navigate } from "@tanstack/react-router";
import type { JSX } from "react";

const ReportsRedirectPage = (): JSX.Element => <Navigate to="/dashboard" />;

export const Route = createFileRoute("/_app/reports/")({
	component: ReportsRedirectPage,
});
